const Regex: { email: RegExp; enrolmentCode: RegExp } = {
  email:
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, // eslint-disable-line
  enrolmentCode: /^\w{4}-\w{4}-\w{4}-\w{4}$/,
}
export default Regex
